// Formatting utilities. Provides both new (dateEs/dateTimeEs, statusLabel object)
// and legacy (fmtDate, num, statusColor as functions) helpers used across pages.

export const money = (v, currency = "MXN") => {
  const n = Number(v || 0);
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export function num(v, digits = 2) {
  const n = Number(v) || 0;
  return n.toLocaleString("es-MX", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export const dateEs = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("es-MX", { year: "numeric", month: "2-digit", day: "2-digit" });
};

export const dateTimeEs = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("es-MX", {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
  });
};

// Legacy signature: fmtDate(iso, withTime = false)
export function fmtDate(iso, withTime = false) {
  return withTime ? dateTimeEs(iso) : dateEs(iso);
}

const _statusLabels = {
  borrador: "Borrador",
  enviada: "Enviada",
  aceptada: "Aceptada",
  rechazada: "Rechazada",
  cerrada: "Cerrada",
};

// Callable as function OR indexable as object.
export function statusLabel(s) {
  if (s === undefined) return _statusLabels;
  return _statusLabels[s] || s;
}
// Also allow bracket access statusLabel[key] via Proxy-like assign
Object.assign(statusLabel, _statusLabels);

export function statusColor(s) {
  return ({
    borrador: "bg-slate-100 text-slate-700 border-slate-300",
    enviada: "bg-blue-50 text-[#005A91] border-[#005A91]/30",
    aceptada: "bg-emerald-50 text-emerald-700 border-emerald-300",
    rechazada: "bg-red-50 text-red-700 border-red-300",
    cerrada: "bg-violet-50 text-violet-700 border-violet-300",
  }[s] || "bg-slate-100 text-slate-700 border-slate-300");
}

export const roleLabel = {
  admin: "Administrador",
  vendedor: "Vendedor",
  tecnico: "Técnico",
};
